import { render, staticRenderFns } from "./integer-type.vue?vue&type=template&id=1cb44d68&scoped=true&lang=pug&"
import script from "./integer-type.vue?vue&type=script&lang=ts&"
export * from "./integer-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb44d68",
  null
  
)

export default component.exports